/** A real per-assignment status — what a row's card treatment is keyed off. */
export type StatusSegment = 'open' | 'closed' | 'scheduled' | 'draft';

/** The selected tab. `all` spans every status rather than naming one. */
export type TabSegment = StatusSegment | 'all';

export const TAB_SEGMENTS: {value: TabSegment; label: string}[] = [
  {value: 'all', label: 'All'},
  {value: 'open', label: 'Open'},
  {value: 'closed', label: 'Closed'},
  {value: 'scheduled', label: 'Scheduled'},
  {value: 'draft', label: 'Draft'}
];

export const CREATE_ASSIGNMENT_PATH = '/assignment-builder/create-assignment';

/** From a class page, carry the class into the builder so it's pre-selected as a recipient. */
export const getCreateAssignmentPath = (classroomId?: string): string =>
  classroomId ? `${CREATE_ASSIGNMENT_PATH}?classroomId=${classroomId}` : CREATE_ASSIGNMENT_PATH;
